import { render, staticRenderFns } from "./SistemaGrupoIndex.vue?vue&type=template&id=4575d155"
import script from "./SistemaGrupoIndex.vue?vue&type=script&lang=js"
export * from "./SistemaGrupoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports